/**
 * HOW MANY DIGITS THE SIGN-IN CODE HAS — one place, because it was three (PROHUB-77).
 *
 * Feedback 002a5902, Phil: "the sign-in email said it was six digits, but it's actually eight."
 *
 * He was right, and the number was written out by hand in four different sentences across two
 * pages, so being wrong once meant being wrong everywhere and fixing it once would not have been
 * enough. The value belongs to Supabase Auth, not to us: the management API reports
 * `mailer_otp_length = 8` for the live project (dyoqjqhkfxpabgzbtetw, read 2026-09-10). The
 * backend's own config.toml declared 6 at the same moment, which is drift with teeth — a deploy
 * applying that file would have shortened the code with nothing to announce it. Corrected there in
 * the same sweep.
 *
 * If Supabase's setting is ever changed deliberately, change it HERE in the same commit and the
 * whole front door follows. Nothing else should spell the number out.
 */
export const OTP_DIGITS = 8;
